"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultAgentProfileTranslate = void 0;
exports.defaultAgentProfileTranslate = {
    phone: 'Phone',
    languageSpoken: 'Language Spoken',
    contactMe: 'Contact Me',
    biography: 'Biography',
    clientTestimonials: 'Client Testimonials',
    recentTransactions: 'Recent Transactions',
    propertyRecommandations: 'Property Recommandations',
    articles: 'Articles',
    transactionNote: '* Above Prices are based on last asking prices',
    viewMore: 'View More',
    viewAllN: 'View All {}',
    leased: "Leased",
    sold: "Sold",
    forSale: "For Sale",
    forRent: "For Rent",
    agentListHeading: 'Tight on time? Let our expert agent do the searching for you',
    agentListAction: 'See All Agents',
};
